import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiInfo } = FiIcons;

export const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="relative inline-block ml-1.5 group">
      <div 
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="cursor-help text-brand-muted hover:text-brand-accent transition-colors"
      >
        <SafeIcon icon={FiInfo} className="text-[10px]" />
      </div>
      {show && (
        <div className="absolute z-[100] bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-brand-text text-white text-[10px] rounded shadow-xl leading-snug animate-in fade-in zoom-in duration-200">
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-brand-text"></div>
        </div>
      )}
    </div>
  );
};